import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Input } from 'antd';
import styled from 'styled-components';

import { LARGE_FIELD } from './constants';
import { Container, ErrorText, Label, RequiredStar } from './form-shared';

const largeInputStyles = `
  font-size: ${LARGE_FIELD.fontSize}px;
  height: ${LARGE_FIELD.height}px;
  input {
    font-size: ${LARGE_FIELD.fontSize}px;
  }
`;

interface StyledInputProps {
  $fullWidth?: boolean;
  $large?: boolean;
}

const StyledInput = styled(Input)<StyledInputProps>`
  ${({ $fullWidth }) => $fullWidth && 'width: 100%;'}
  ${({ $large }) => $large && largeInputStyles}
`;

const StyledPassword = styled(Input.Password)<StyledInputProps>`
  ${({ $fullWidth }) => $fullWidth && 'width: 100%;'}
  ${({ $large }) => $large && largeInputStyles}
`;

interface FormTextFieldProps {
  label?: string;
  type?: string;
  style?: React.CSSProperties;
  name: string;
  size?: 'large' | 'middle' | 'small';
  fullWidth?: boolean;
  required?: boolean;
  autoComplete?: string;
}

function FormTextField({
  label,
  type,
  style,
  name,
  size = 'large',
  fullWidth,
  required,
  autoComplete
}: FormTextFieldProps) {
  const ctx = useFormContext();
  const control = ctx?.control ?? undefined;
  const isLarge = size === 'large';
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <Container style={style} $fullWidth={fullWidth}>
          {label && (
            <Label>
              {label}
              {required && <RequiredStar>*</RequiredStar>}
            </Label>
          )}
          {type === 'password' ? (
            <StyledPassword
              {...field}
              $large={isLarge}
              $fullWidth={fullWidth}
              autoComplete={autoComplete}
            />
          ) : (
            <StyledInput
              {...field}
              type={type}
              $large={isLarge}
              $fullWidth={fullWidth}
              autoComplete={autoComplete}
              readOnly
              onFocus={(e) => e.target.removeAttribute('readonly')}
            />
          )}
          {error && <ErrorText>{error?.message}</ErrorText>}
        </Container>
      )}
    />
  );
}

export default FormTextField;
